"use client";

import { Link } from "@/i18n/navigation";

export default function ErrorPage({ error }: { error: Error }) {
  return (
    <>
      <Link href={"/"} className="error-page">
        <p className="info">{error.message}</p>
        <h1 className="internal">
          <span className="five">5</span>
          <span className="zero">0</span>
          <span className="zero">0</span>
        </h1>
      </Link>
    </>
  );
}
